<template>
  <div class="view">
    <video
      id="video"
      src="https://eage-cloud.oss-cn-hangzhou.aliyuncs.com/pro/tutorial/%E6%99%BA%E8%83%BD%E6%8F%92%E5%BA%A7.mp4"
      controls
      controlsList="nodownload noplaybackrate"
      disablePictureInPicture
    ></video>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},

  props: {},

  data() {
    return {
      id: null,
      detail: {}
    }
  },

  filters: {},
  computed: {},
  watch: {},

  created() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.view {
  height: 100%;

  #video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
